export var RouterLinkRedirectType = /*#__PURE__*/function (RouterLinkRedirectType) {
  // Replace is the commonly used mode. The route will be redirected.
  // Also routerLinkActive will indicate active route based on the replacement route.
  RouterLinkRedirectType["Replace"] = "Replace";
  // The route will be redirected. However, routerLinkActive will compare to the un-replaced route.
  // This is useful for special situations, typically redirection to a child route.
  // example: The /management route is redirected to /management/courses, 
  // but elements linking to /management will indicate being active for /management/*.
  RouterLinkRedirectType["Redirect"] = "Redirect";
  return RouterLinkRedirectType;
}(RouterLinkRedirectType || {});
;